import { OgpApiService } from './ogp-api-service';
import { GetWorkersPoolsResponse } from './workers-pool-service.types';

export class WorkersPoolsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getWorkersPools = async (params: {
    page: number;
    pageSize: number;
  }): Promise<GetWorkersPoolsResponse> => {
    return await this.ogpApiService.get<GetWorkersPoolsResponse>({
      path: `workers-pools`,
      params: { ...params },
    });
  };

  public createWorkersPool = async (body: {
    name: string;
    description?: string;
    serviceAgreementIds: string[];
  }): Promise<string> => {
    return await this.ogpApiService.create<string>({
      path: `workers-pools`,
      body: { ...body },
    });
  };
}
